import { TransitionKind } from "@repo/api/transition";
import {
  getDefaultDurationInFrames,
  getDefaultPreviewClipDurationsInFrames,
  getDefaultTiming,
  ImageTransitionBuilder,
} from "./ImageTransitionBuilder.ts";
import {
  autoSizedClockWipe,
  AutoSizedClockWipeProps,
} from "./ClockWipePresentation.tsx";

const transitionKind = TransitionKind.enum.CLOCK_WIPE;

export const ImageClockWipeTransitionBuilder: ImageTransitionBuilder<AutoSizedClockWipeProps> =
  {
    formConfig: {
      kind: transitionKind,
      buildDefaultValue: () => ({ kind: transitionKind, speed: "NORMAL" }),
      speed: ["SLOW", "NORMAL", "FAST"],
    },

    transition: {
      getDurationInFrames: getDefaultDurationInFrames,
      buildPresentation: () => autoSizedClockWipe(),
      buildTiming: getDefaultTiming,
    },

    getPreviewClipDurationsInFrames: getDefaultPreviewClipDurationsInFrames,
  };
